import { IFiterSearch } from 'redhotpie-shared-lib/interfaces/IFilter';
import FilterSearch from './filterSearch';
import { ISaveSearchItem } from 'redhotpie-shared-lib/interfaces/ISaveSearch';

class SaveSearchItem {
  id: number;
  title: string;
  config?: IFiterSearch;
  dateCreated: string;

  constructor() {
    this.id = -1;
    this.title = '';
    this.config = undefined;
    this.dateCreated = '';
  }

  static mappingItem(object: any): ISaveSearchItem {
    const obj = new SaveSearchItem();
    obj.id = object.SavedSearchID || -1;
    obj.title = object.Title || '';
    obj.config = FilterSearch.mappingObject(object.Config) || undefined;
    obj.dateCreated = object.DateCreated || '';

    return obj;
  }
}

export default class SavedSearches {
  constructor() {
    // this.data = [];
  }

  static mappingListData(list: any): ISaveSearchItem[] {
    const savedSearches: ISaveSearchItem[] = [];
    list.forEach((item: any) => {
      savedSearches.push(SaveSearchItem.mappingItem(item));
    });
    return savedSearches;
  }
}
